import React from "react";

import styles from "./Header.module.css"
import logo from "../../assets/ddmlogo.webp";

import {Fragment} from "react";
import {NavLink} from 'react-router-dom';
import { useSelector} from 'react-redux';

import Navigation from "./Navigation";
import Notification from "../notification/Notification";
import ClearFix from "../common/ClearFix";

import * as routeConstants from "../../constants/routeConstants";

const Header = () => {
    const auth = useSelector((state) => state.auth);
    const notification = useSelector((state) => state.notification);
    
/* Hidden logout button because app will be integrated & not standalone
    const dispatch = useDispatch();

    const logoutHandler = () => {
        dispatch(logout(true));
    }
*/

    return (
        <Fragment>
        <header className={styles.header}>
            <div className={styles.innerHeader} >
                <div className={styles.logo}>
                <img src={logo} alt="Beautiful DDM logo"/>
                </div>
                <h2 className={styles.title}>Skill matrix</h2>
                <div className={styles.headerRight}>
                    <Navigation />
                    <div className={styles.actions}>
                        {/*auth.isLoggedIn && <button onClick={logoutHandler}>Logout</button>   /*Hiding logout button because it'll also sign out the user in genesys and app will be intergrated, not stand-alone */}
                        {!auth.isLoggedIn && <NavLink to={routeConstants.ROUTE_AUTH}>Login</NavLink>}
                    </div>
                </div>
                <ClearFix />
            </div>
            {notification.notification && <Notification 
                status={notification.notification.status}
                message={notification.notification.message}
            />}
        </header>

        <div className={styles.headerShadow} />
        </Fragment>
    )
}

export default Header;